import { defineStore } from 'pinia'
import { getImagesForProduct } from '@/services/productImage'

import type { ImageMap } from '@/services/productImage'

export const useProductImageStore = defineStore('productImages', {
  state: () => ({
    productImages: {} as Record<string, ImageMap[] | null | undefined>,
  }),
  actions: {
    async getImagesForProduct(id: string) {
      if (!Object.hasOwnProperty.call(this.productImages, id)) {
        const [productId, variantId] = id.split(':')
        this.productImages[id] = await getImagesForProduct(productId, variantId)
      }
    },
    async loadImagesForProducts(ids: string[]) {
      const uniqueIdsWithoutImages = ids.reduce((ids, id) => {
        if (!Object.hasOwnProperty.call(this.productImages, id)) {
          ids.add(id)
        }
        return ids
      }, new Set<string>())
      return Promise.all(
        Array.from(uniqueIdsWithoutImages).map((id) => {
          return this.getImagesForProduct(id)
        }),
      )
    },
  },
})
